import { useState } from 'react';
import { Table, Button, Popconfirm } from 'antd';
import DayJS from 'dayjs';
import { ExclamationCircleFilled, CheckCircleFilled, EditFilled, DeleteFilled } from '@ant-design/icons';
import useSWR from 'swr';

import { deleteInvoice } from '~/libs/requests';
import { moneyFormatter, useHandleSWR, nodesTitleResolver } from '~/libs/helpers';
import useGlobalState from '~/libs/context';
import { StyledTable } from './styles/StyledTable';

const itemsPerPage = 10;

const UploadsList = (props) => {
  const { year } = useGlobalState();
  const [ busyDeleting, setBusyDeleting ] = useState(false);
  const [ page, setPage ] = useState(1);
  const [ selectionType, setSelectionType ] = useState('checkbox');

  const { data: invoices, isValidating: busyLoading, mutate: mutateInvoices } = 
    useSWR(`/api/invoices?limit=${itemsPerPage}&skip=${(page - 1) * itemsPerPage}&year=${year}`);

  const { data: swrAccount, mutate: mutateAccount } = useSWR('/api/account');
  const { data: account, busy: busyAccount } = useHandleSWR(swrAccount, [], true);

  let settings = account?.settings;
  let projects = settings?.projects || [];

  const onDelete = async (invoiceId) => {
    setBusyDeleting(true);
    await deleteInvoice(invoiceId);
    mutateInvoices();
    //mutate(['/api/invoices', itemsPerPage, (page - 1) * itemsPerPage]);
    setBusyDeleting(false);
  }

  const onEditClick = (invoice) => {
    if (props.onEditClick) {
      props.onEditClick(invoice);
    }
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: x => ({ disabled: !x.isValid }),
  };

  const renderProject = (projectId) => {
    let project = projectId ? nodesTitleResolver(projectId, projects) : <span>Error</span>;
    return project;
  }

  const isValidInvoice = (invoice) => {
    return invoice.date && invoice.amount && invoice.projectId;
  }

  const isPaidInvoice = (invoice) => {
    return isValidInvoice(invoice) && invoice.isPaid;
  }

  const columns = [
    { title: '', dataIndex: 'isValid', key: 'isValid', width: 20,
      render: (_x, data) => isPaidInvoice(data) ? <CheckCircleFilled style={{ fontSize: 24, color: '#2590ff' }} /> :
        (isValidInvoice(data) ? <CheckCircleFilled style={{ fontSize: 24, color: '#ffba25' }} /> : 
        <ExclamationCircleFilled style={{ fontSize: 24, color: '#f94d4f' }} />),
    },
    { title: 'Date', dataIndex: 'date', key: 'date', width: 80,
      render: x => x ? DayJS(new Date(x)).format('MM/DD') : <i style={{ color: '#f94d4f' }}>Missing</i> },
    { title: 'Details', dataIndex: 'details', key: 'details',
      render: x => x ? x : '-' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount',
      render: x => x ? moneyFormatter(x) : <i style={{ color: '#f94d4f' }}>Missing</i> },
    { title: 'Project', dataIndex: 'projectId', key: 'projectId',
      render: x => x ? renderProject(x) : <i style={{ color: '#f94d4f' }}>Missing</i> },
    { title: 'Action', width: 83, key: 'action', render: (text, invoice) => (
      <span style={{ marginRight: -10 }}>
        <Button type="primary" icon={<EditFilled />} style={{ marginRight: 5 }}
          onClick={() => onEditClick(invoice)}></Button>
        <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => onDelete(invoice._id)}>
          <Button danger icon={<DeleteFilled />}></Button>
        </Popconfirm>
      </span>
    )}
  ];

  return (
    <StyledTable rowKey='_id' size='small'
      //rowSelection={{ type: 'checkbox', ...rowSelection }}
      onRow={invoice => { return { onDoubleClick: () => onEditClick(invoice) } }}
      columns={columns}
      dataSource={invoices ? invoices.data : null}
      pagination={{ 
        current: page,
        defaultPageSize: itemsPerPage,
        total: invoices ? invoices.total : 0,
        onChange: (p) => setPage(p)
      }}
      loading={busyLoading || busyDeleting} 
    />
  );
}

export default UploadsList;